<script>
import { Validator, } from "@/plugins/validator";
import { insuranceMetaFields as metaFields } from "./metaFields";

export default {
    name: "InsuranceDetailsModal",

    data() {

        return {
            insuranceSchemes: [],
            errors: [],
        };
    },

    props: {

        showModal: Boolean,
        insurances: Array,
        dependants: Array,
        patientInsurance: Object,
        patient: Object,
    },

    watch: {

        'patientInsurance.organizationID' () {
            if(!this.patientInsurance.organizationID) return;

            this.fetchInsuranceSchemes();
        },

        "patientInsurance.principalOfDependantId"() {
            if(!this.patientInsurance.principalOfDependantId) return;

            const dependants = this.dependants.filter(dep => dep.principalOfDependantId == this.patientInsurance.principalOfDependantId);

            if(!dependants.length) return;

            if(dependants[0].principalOfDependant == `Self`) {

                this.patientInsurance.patientName = `${this.patient.firstname} ${this.patient.lastname}`;
                this.patientInsurance.patientIDNO = this.patient.nationalid;
            } else {
                this.patientInsurance.patientName = ``;
                this.patientInsurance.patientIDNO = ``;
            }
        },
    },

    methods: {

        fetchInsuranceSchemes() {
            this.$root.loading = true;
            this.$http.get(`Shared/GetSchemesForOrganization?OrganizationID=${this.patientInsurance.organizationID}`).then(response => {
                this.insuranceSchemes = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },

        saveData() {

            new Validator(this.patientInsurance, metaFields).validate().then(() => {
                this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientInsuranceDetails`, this.patientInsurance).then(response => {
                    this.errors = [];
                    this.$root.loading = false;
                    window.Swal.fire({ text: response.data, type: 'success', showCancelButton: false });
                    this.$emit('refresh');
                    this.$emit('closeModal');
                }).catch(() => { this.$root.loading = false; });
            }).catch(errors => {
                this.errors = errors;
            });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="sm:11/12 md:w-2/3">
      <template v-slot:title>
        <h5 class="font-bold text-base">Insurance details</h5>
      </template>
      <template v-slot:modal-body>
          <div class="flex flex-wrap -m-3">
            <div class="w-full border-b-2 border-blue-500 py-1">
                <h5 class="font-bold text-sm">Principal Details:</h5>
            </div>
            <div class="flex-1 flex flex-wrap">
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-insurance" class="label-control">Insurance:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-insurance" v-model="patientInsurance.organizationID" class="input-control input-sm text-xs">
                                <option value="">Select insurance</option>
                                <option v-for="(insurance, idx) in insurances" :value="insurance.organizationID" :key="idx">{{ insurance.organization }}</option>
                            </select>
                        </template>
                    </tail-select>
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'organizationID').length">
                        {{ errors.filter(error => error.field == 'organizationID')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-scheme" class="label-control">Scheme:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-scheme" v-model="patientInsurance.schemeID" class="input-control input-sm text-tiny">
                                <option value="">Select scheme</option>
                                <option v-for="(insuranceScheme, idx) in insuranceSchemes" :key="idx" :value="insuranceScheme.schemeId">{{ insuranceScheme.schemeName }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-dependant" class="label-control">Dependant:</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="grid-dependant" v-model="patientInsurance.principalOfDependantId" class="input-control input-sm text-tiny">
                                <option value="">Select dependant</option>
                                <option v-for="(dependant, idx) in dependants" :key="idx" :value="dependant.principalOfDependantId">{{ dependant.principalOfDependant }}</option>
                            </select>
                        </template>
                    </tail-select>
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'principalOfDependantId').length">
                        {{ errors.filter(error => error.field == 'principalOfDependantId')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-member-no" class="label-control">Member No:</label>
                    <input type="text" v-model.trim="patientInsurance.memberNo" id="grid-member-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberNo').length">
                        {{ errors.filter(error => error.field == 'memberNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-confirm-member-no" class="label-control">Confirm Member No:</label>
                    <input type="text" v-model.trim="patientInsurance.confirmMemberNo" id="grid-confirm-member-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'confirmMemberNo').length">
                        {{ errors.filter(error => error.field == 'confirmMemberNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-id-no" class="label-control">ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.memberIDNo" id="grid-id-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberIDNo').length">
                        {{ errors.filter(error => error.field == 'memberIDNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-confirm-id-no" class="label-control">Confirm ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.confirmMemberIDNo" id="grid-confirm-id-no" class="input-sm input-control text-xs">
                    <p class="form-text-error" v-if="errors.filter(error => error.field == 'confirmMemberIDNo').length">
                        {{ errors.filter(error => error.field == 'confirmMemberIDNo')[0].message }}</p>
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny">
                    <label for="grid-employer-2" class="label-control">Employer:</label>
                    <input type="text" v-model.trim="patientInsurance.employer" id="grid-employer-2" class="input-sm input-control text-xs">
                </div>
                <div class="md:w-1/5 sm:w-full p-tiny pt-3">
                    <label for="grid-active" class="label-control mt-4">Active <input type="checkbox" v-model="patientInsurance.active" id="grid-active"></label>
                </div>
            </div>
            <div class="w-full border-b-2 border-indigo-300 py-1">
                <h5 class="font-bold text-sm">Patient Insurance Details:</h5>
            </div>
            <div class="flex-1 flex flex-wrap">
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-name" class="label-control">Name:</label>
                    <input type="text" v-model.trim="patientInsurance.patientName" id="grid-patient-name" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-id-number" class="label-control">ID No:</label>
                    <input type="text" v-model.trim="patientInsurance.patientIDNO" id="grid-patient-id-number" class="input-control input-sm text-xs">
                </div>
                <div class="md:w-1/3 sm:w-full p-tiny">
                    <label for="grid-patient-member-number" class="label-control">Dependant No:</label>
                    <input type="text" v-model.trim="patientInsurance.dependantNO" id="grid-patient-member-number" class="input-control input-sm text-xs">
                </div>
            </div>
          </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-sm rounded mr-4" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-sm rounded" @click.stop="saveData"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>